import React from 'react'
import { useWindowScroll, useClickAway } from 'react-use'
import { useNavigate, Navigate } from 'react-router-dom'

// Config
import l, { c, isGs } from 'config/localization'

// Load components synchronously
import ConditionalDisplay from 'components/ConditionalDisplay/ConditionalDisplay'
import CookieHeader from 'components/CookieHeader'
import FlashMessage from 'components/FlashMessage'
import ProfileMenu from 'components/ProfileMenu'

// Styles
import {
  ChampionBtn,
  LogoLink,
  MainNavWrapper,
  NavBar,
  NavBarContent,
  NavLinkItem,
  NavLinksWrapper,
  PricingDropdownItem,
  PricingDropdownWrapper,
  ScrollToTop
} from './styles'

// Assets - Images
import logo from 'assets/images/svgs/bp_logo.svg'

const DiscoverDropdown = ({ goTo, discoverDropdownVisible, toggleDiscoverDropdown }) => {
  const ref = React.useRef(null)
  useClickAway(
    ref,
    () => {
      if (discoverDropdownVisible) {
        toggleDiscoverDropdown()
      }
    },
    ['click']
  )

  if (!discoverDropdownVisible) return null

  return (
    <PricingDropdownWrapper ref={ref}>
      <PricingDropdownItem onClick={() => goTo(`/search/${l('ROUTE_OPPS')}`)}>
        {c(l('OPPS'))}
      </PricingDropdownItem>

      <PricingDropdownItem onClick={() => goTo(`/search/nonprofits`)}>
        Nonprofits
      </PricingDropdownItem>

      <PricingDropdownItem onClick={() => goTo(`/search/companies`)}>Companies</PricingDropdownItem>
    </PricingDropdownWrapper>
  )
}

const PricingDropdown = ({ goTo, pricingDropdownVisible, togglePricingDropdown }) => {
  const ref = React.useRef(null)
  useClickAway(
    ref,
    () => {
      if (pricingDropdownVisible) {
        togglePricingDropdown()
      }
    },
    ['click']
  )

  if (!pricingDropdownVisible) return null

  return (
    <PricingDropdownWrapper ref={ref}>
      <PricingDropdownItem onClick={() => goTo(`/pricing/nonprofits`)}>
        Nonprofits
      </PricingDropdownItem>
      <PricingDropdownItem onClick={() => goTo(`/pricing/business`)}>Business</PricingDropdownItem>
      <PricingDropdownItem onClick={() => goTo(`/pricing/education`)}>
        Education
      </PricingDropdownItem>
    </PricingDropdownWrapper>
  )
}

const NavBarComponent = ({
  isLoading,
  discoverDropdownVisible,
  pageType,
  pricingDropdownVisible,
  toggleMenuModal,
  toggleDiscoverDropdown,
  togglePricingDropdown,
  userData
}) => {
  const isSearchPage = pageType === 'searchPage'
  const isHomePage = pageType === 'homePage'
  const isPricingPage = pageType === 'pricingPage'
  const displayGoodDeedsButton = pageType !== 'storiesPage'
  // const isTermsPage = pageType === 'termsPage'
  // const isStoryPage = pageType === 'storyPage'
  // const isPrivacyPage = pageType === 'privacyPage'

  if (userData && userData.on_probation) {
    return <Navigate to={`/probation`} replace />
  }

  const navigate = useNavigate()
  const goTo = link => {
    toggleMenuModal('close')
    navigate(link)
  }

  const { y } = useWindowScroll()
  const transparent = y < 85

  if (isGs) return null

  return (
    <MainNavWrapper homepage={isHomePage} transparent={transparent}>
      <NavBar isLoading={isLoading} homepage={isHomePage} transparent={transparent}>
        <NavBarContent>
          <LogoLink onClick={() => goTo('/')}>
            <img src={logo} width="121" height="44" alt="Brownie Points logo" />
          </LogoLink>

          <NavLinksWrapper>
            <div>
              <NavLinkItem onClick={() => toggleDiscoverDropdown()} active={isSearchPage}>
                Discover
              </NavLinkItem>

              <DiscoverDropdown
                goTo={goTo}
                discoverDropdownVisible={discoverDropdownVisible}
                toggleDiscoverDropdown={toggleDiscoverDropdown}
              />
            </div>

            <div>
              <NavLinkItem onClick={() => togglePricingDropdown()} active={isPricingPage}>
                Solutions
              </NavLinkItem>

              <PricingDropdown
                goTo={goTo}
                pricingDropdownVisible={pricingDropdownVisible}
                togglePricingDropdown={togglePricingDropdown}
              />
            </div>

            <ConditionalDisplay displayWhen={[displayGoodDeedsButton]}>
              <ChampionBtn onClick={() => goTo(`/stories`)}>Share a good deed</ChampionBtn>
            </ConditionalDisplay>
          </NavLinksWrapper>

          <ScrollToTop />

          <ProfileMenu toggleMenuModal={toggleMenuModal} />
        </NavBarContent>
      </NavBar>

      <CookieHeader />
      <FlashMessage />
    </MainNavWrapper>
  )
}

export default NavBarComponent
